﻿import tippy from 'tippy.js';

(function (document) {
    document.addEventListener('DOMContentLoaded', function (e) {
        var iconElement, headingElement, template;

        headingElement = document.querySelector('[data-system-menu]');
        if (headingElement != null) {
            iconElement = document.querySelector('[data-system-menu-icon]');

            template = document.querySelector(headingElement.dataset.systemMenu);
            template.style.display = 'block';

            tippy(
                iconElement, {
                    theme: 'light',
                    content: template,
                    trigger: 'click',
                    interactive: 'true',
                    triggerTarget: headingElement,
                }
            );
        }
    });
})(document);